import React from "react";
import { Dropdown, Flex, Typography } from "antd";
import {
  CheckOutlined,
} from "@ant-design/icons";
import classname from "classname";
import Icon from "../../../../../Icon";
import { descriptorStatusTypeMap } from "../../../utils/Enrollment.util";
import "./DescriptorHeaderAddon.less";

const { Text } = Typography;

const STATUS_OPTIONS = [
  { key: "active", label: "Active" },
  { key: "pending", label: "Pending" },
  { key: "in_re_enrollment", label: "In re-enrollment" },
  { key: "needs_assistance", label: "Needs assistance" },
  { key: "in_progress", label: "In progress" },
  { key: "verification_needed", label: "Verification needed" },
  { key: "enrolled_elsewhere", label: "Enrolled elsewhere" },
  { key: "generic_descriptor", label: "Generic descriptor" },
  { key: "banned_descriptor", label: "Banned descriptor" },
  { key: "invalid_arns", label: "Invalid ARNs" },
  { key: "invalid_descriptor", label: "Invalid descriptor" },
  { key: "pending_unenroll", label: "Pending unenroll" },
  { key: "unenrolled", label: "Unenrolled" },
];

const TYPE_OPTIONS = [
  { key: "Exact match", label: "Exact match" },
  { key: "Starts with", label: "Starts with" },
];

const DescriptorHeaderAddon = ({
  status,
  descriptorType,
  onStatusChange,
  onDescriptorTypeChange,
}) => {
  const selectedStatus = STATUS_OPTIONS.find(item => item.key === status);
  const selectedType = TYPE_OPTIONS.find(
    (item) =>
      item.label === descriptorType ||
      item.key === descriptorType ||
      (descriptorType === "exact_match" && item.key === "Exact match") ||
      (descriptorType === "starts_with" && item.key === "Starts with"),
  );
  const selectedStatusType = descriptorStatusTypeMap[selectedStatus?.key] || "pending";

  const getStatusMenuItems = () =>
    STATUS_OPTIONS.map(item => ({
      key: item.key,
      label: (
        <Flex align="center" justify="space-between" gap={24}>
          <Flex align="center" gap={14}>
            <span
              className={classname(
                "descriptor-addon-dot",
                `descriptor-addon-dot-${descriptorStatusTypeMap[item.key] || "pending"}`,
              )}
            />
            <span
              className={classname(
                "descriptor-addon-status-option",
                // descriptorStatusTypeMap[item.key] || "pending",
              )}
            >
              {item.label}
            </span>
          </Flex>

          {item.key === status && (
            <CheckOutlined className="descriptor-addon-check" />
          )}
        </Flex>
      ),
    }));

  const getTypeMenuItems = () =>
    TYPE_OPTIONS.map(item => ({
      key: item.key,
      label: (
        <Flex align="center" justify="space-between" gap={24}>
          <span>{item.label}</span>

          {item.label === descriptorType && (
            <CheckOutlined className="descriptor-addon-check" />
          )}
        </Flex>
      ),
    }));

  return (
    <Flex align="center" gap={8} className="descriptor-header-addon">
      <Dropdown
        trigger={["click"]}
        menu={{
          items: getTypeMenuItems(),
          onClick: ({ key }) => {
            const option = TYPE_OPTIONS.find(item => item.key === key);
            onDescriptorTypeChange?.(option);
          },
        }}
        overlayClassName="descriptor-addon-dropdown descriptor-addon-type-dropdown"
      >
        <Flex align="center" gap={6} className="descriptor-addon-trigger">
          <Text type="secondary" strong>
            {selectedType?.label || descriptorType || "Exact match"}
          </Text>
          <Icon type="chevron_down_small" className="descriptor-addon-arrow" />
        </Flex>
      </Dropdown>

      <span className="descriptor-addon-divider" />

      <Dropdown
        trigger={["click"]}
        menu={{
          items: getStatusMenuItems(),
          onClick: ({ key }) => {
            const option = STATUS_OPTIONS.find(item => item.key === key);
            onStatusChange?.(option);
          },
        }}
        overlayClassName="descriptor-addon-dropdown descriptor-addon-status-dropdown"
      >
        <Flex
          align="center"
          gap={6}
          className={classname(
            "descriptor-addon-trigger",
            "descriptor-addon-status-trigger",
            `descriptor-addon-status-${selectedStatusType}`,
          )}
        >
          <Text strong>{selectedStatus?.label || status}</Text>
          <Icon type="chevron_down_small" className="descriptor-addon-arrow" />
        </Flex>
      </Dropdown>
    </Flex>
  );
};

export default DescriptorHeaderAddon;
